// nivel-style.ts — constante compartida de fallback para niveles de puesto.
// Usada en PuestoDetailPage, AdminPuestos, PuestoNode, PuestosListPage.
// Elimina las 4 declaraciones duplicadas de NIVEL_FALLBACK.

export const NIVEL_FALLBACK = {
  color: '#6B7280',
  bg: '#F3F4F6',
} as const;
